import * as React from 'react';
import { ButtonProps, CircularProgress, Stack, Typography } from '@mui/material';
import { Button } from '@mui/material';
import { notNull } from 'common/utils/common';

export type ButtonStyle = 'primary' | 'primary_outlined' | 'success' | 'danger';
export type RentalStateCta = {
	label: string;
	onClick: () => void;
	loading?: boolean;
	disabled?: boolean;
	style: ButtonStyle;
	dataQa?: string;
};

interface Props {
	ctas: (RentalStateCta | null)[];
	errorMessage?: string | null;
}

export const ChangeRentalState = (props: Props) => {
	const { ctas, errorMessage } = props;

	const getButtonStyleProps = (style: ButtonStyle): Partial<ButtonProps> => {
		switch (style) {
			case 'primary':
				return {
					variant: 'contained',
					color: 'primary',
					size: 'large',
				};
			case 'primary_outlined':
				return {
					variant: 'outlined',
					color: 'primary',
					size: 'large',
				};
			case 'success': {
				return {
					variant: 'contained',
					color: 'success',
					size: 'large',
				};
			}
			case 'danger': {
				return {
					variant: 'text',
					color: 'error',
					size: 'small',
				};
			}
		}
	};

	const renderCta = (cta: RentalStateCta) => {
		return (
			<Button
				{...getButtonStyleProps(cta.style)}
				key={cta.label}
				disabled={cta.disabled || cta.loading}
				fullWidth
				onKeyPress={(event) => {
					event.preventDefault();
				}}
				onClick={cta.onClick}
				data-qa={cta.dataQa}
			>
				{cta.loading ? <CircularProgress size={20} color="inherit" /> : cta.label}
			</Button>
		);
	};

	return (
		<Stack direction="column" alignItems="stretch" spacing={1.5}>
			{errorMessage && <Typography color="error">{errorMessage}</Typography>}
			{ctas.filter(notNull).map(renderCta)}
		</Stack>
	);
};

export default ChangeRentalState;
